import { FC, useState } from "react";
import ThemeIconSVG from "../shared/svg/console/ThemeIconSVG";
import { ThemeEnum } from "../../domain/enums/common/ThemeEnum";

interface ConsoleThemeToggleProps {
    theme: ThemeEnum;
}

const IconColorClass = {
    [ThemeEnum.DARK]: { default: "text-dark-fill-100", hover: "text-white" },
    [ThemeEnum.LIGHT]: { default: "text-light-fill-100", hover: "text-black" },
};

const ConsoleThemeToggle: FC<ConsoleThemeToggleProps> = ({ theme }) => {
    const [isHovered, setIsHovered] = useState(false);
    const iconColor = isHovered ? IconColorClass[theme].hover : IconColorClass[theme].default;

    return (
        <div
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className="w-7 h-7 flex-shrink-0"
        >
            <ThemeIconSVG className={`${iconColor} w-7 h-7`} />
        </div>
    );
};

export default ConsoleThemeToggle;
